import { ActionReducerMapBuilder, PayloadAction } from "@reduxjs/toolkit";
import { calcTariffRate, fetchFinanceby, fetchpVAPIMonthly, fetchpVAPIMonthlyCase2, generationdegradation, generationdegradationwithfinance, generationdegradationwithfinance2, getCostBracket } from "./ConsumerActions";
import { EnvironmentalImpact, FinRes, initialstateType } from "./types";
import { ProjectTy } from "../Auth/types";
import { deleteProjectbyId, saveConsumerProjects, updateOrderStatusCard, getProjectsByProjectid, getPrtojects } from "./ProjectServices/projectServices";
import { initailFromdata, initialState } from "./ConsumerReducers";
import { GenerationKey, GenerationPerformance } from "../../../Utils/Const";

export const ConsumerBuilders = (builder: ActionReducerMapBuilder<initialstateType>) => {
  builder
    .addCase(getPrtojects.fulfilled, (state, { payload }: PayloadAction<ProjectTy[]>) => {
      state.projects = payload;
      state.isLoading = false;
      state.projectLoader = ""
    }).addCase(getPrtojects.pending, (state, { payload }) => {
      state.isLoading = true;
      state.projects = null;
      state.projectLoader = "globalprojectloader"
    }).addCase(getPrtojects.rejected, (state, { payload }) => {
      state.isLoading = false;
      state.projects = null;
      state.projectLoader = ""
    })
    //getProjectsByProjectid
    .addCase(getProjectsByProjectid.fulfilled, (state, { payload }: PayloadAction<ProjectTy>) => {
      state.roofAnalysis.selected_project = JSON.parse(JSON.stringify(payload));
      state.isLoading = false;
    }).addCase(getProjectsByProjectid.pending, (state, { payload }) => {
      state.isLoading = true;
      state.roofAnalysis.selected_project = null;
    }).addCase(getProjectsByProjectid.rejected, (state, { payload }) => {
      state.isLoading = false;
      state.roofAnalysis.selected_project = null;
    })
    //saveConsumerProjects
    .addCase(saveConsumerProjects.fulfilled, (state, { payload }: PayloadAction<ProjectTy>) => {
      // Merge into the same project: a PUT response may leave fields out (e.g. projectcost, savingperiod),
      // and replacing the object dropped them, so cards showed "INR 0" until the next reload
      const current = state.roofAnalysis.selected_project;
      state.roofAnalysis.selected_project = current && payload && current.projectid === payload.projectid
        ? { ...current, ...Object.fromEntries(Object.entries(payload).filter(([, v]) => v !== null && v !== undefined)) } as ProjectTy
        : payload;
      state.roofAnalysis.formDetails.projectSetup.houseblock = payload?.projectlocation?.houseblock ?? "";
      state.roofAnalysis.formDetails.projectSetup.roadarea = payload?.projectlocation?.roadarea ?? "";
      state.roofAnalysis.formDetails.projectSetup.city = payload?.projectlocation?.city ?? "";
      state.roofAnalysis.formDetails.projectSetup.state = payload?.projectlocation?.state ?? "";
      state.roofAnalysis.formDetails.projectSetup.country = payload?.projectlocation?.country ?? "";
      state.roofAnalysis.formDetails.projectSetup.pincode = payload?.projectlocation?.pincode ?? "";
      state.isLoading = false;
    }).addCase(saveConsumerProjects.pending, (state, { payload }) => {
      // Keep the current project while saving (clearing it blanked the cards and let a save during the gap
      // see "no project"); a failed save also keeps it, the backend copy is unchanged
      state.isLoading = true;
    }).addCase(saveConsumerProjects.rejected, (state, { payload }) => {
      state.isLoading = false;
    })
    //calcTariffRate
    .addCase(calcTariffRate.fulfilled, (state, { payload }: PayloadAction<number>) => {
      state.roofAnalysis.formDetails.projectSetup.electricityrate = payload;
      state.isLoading = false;
    }).addCase(calcTariffRate.pending, (state, { payload }) => {
      state.isLoading = true;
      state.roofAnalysis.formDetails.projectSetup.electricityrate = 0;
    }).addCase(calcTariffRate.rejected, (state, { payload }) => {
      state.isLoading = false;
      state.roofAnalysis.formDetails.projectSetup.electricityrate = 0;
    })
    //updateOrderStatusCard
    .addCase(updateOrderStatusCard.fulfilled, (state, { payload }: PayloadAction<any>) => {
      const index = state.projects!.findIndex((item) => item.projectid === payload.projectid);
      if (index !== -1) {
        state.projects![index] = payload;
        state.isLoading = false;
      } else {
        state.projects!.push(payload);
      }
    })
    .addCase(updateOrderStatusCard.pending, (state, { payload }) => {
      state.isLoading = true;
    })
    .addCase(updateOrderStatusCard.rejected, (state, { payload }) => {
      state.isLoading = false;
    })
    .addCase(getCostBracket.fulfilled, (state, { payload }) => {
      // debugger
      state.roofAnalysis.formDetails.quickplantAnalysis.costbracket = payload;
      state.isLoading = false
    })
    .addCase(getCostBracket.pending, (state, { payload }) => {
      state.isLoading = true
    })
    .addCase(getCostBracket.rejected, (state, { payload }) => {
      state.roofAnalysis.formDetails.quickplantAnalysis.costbracket = "";
      state.isLoading = false
    })
    .addCase(fetchpVAPIMonthly.fulfilled, (state, { payload }: PayloadAction<{ generation: any, stringPerModule: number }>) => {
      const data = payload?.generation ?? null

      state.roofAnalysis.formDetails.quickplantAnalysis.stringPerModule = payload?.stringPerModule
      if (typeof data === 'object' && data !== null && Object.keys(data).length > 0) {
        state.roofAnalysis.formDetails.quickplantAnalysis.electricityGenerated = data['Annual AC energy in Year 1']
        // state.roofAnalysis.formDetails.quickplantAnalysis.electricityGenerated = data['Energy yield in Year 1'][0] // wrong call
        // state.roofAnalysis.formDetails.quickplantAnalysis.electricityGenerated = data[GenerationKey][0]
        // state.roofAnalysis.formDetails.quickplantAnalysis.electricityGenerated = data[GenerationKey]
        state.roofAnalysis.formDetails.quickplantAnalysis.performanceRatio = data[GenerationPerformance][0]
      }
      state.isLoading = false;
    })
    .addCase(fetchpVAPIMonthly.pending, (state, action) => {
      state.isLoading = true
    })
    .addCase(fetchpVAPIMonthly.rejected, (state, { payload }) => {
      state.isLoading = false;
    })
    // sanctionload
    .addCase(fetchpVAPIMonthlyCase2.fulfilled, (state, { payload }: PayloadAction<string>) => {
      const data = JSON.parse(payload);
      // state.roofAnalysis.formDetails.quickplantAnalysis.electricityGenerated2 = data['Annual AC energy in Year 1']
      if (typeof data === 'object' && data !== null && Object.keys(data).length > 0) {
        // state.roofAnalysis.formDetails.quickplantAnalysis.electricityGenerated2 = data['Annual AC energy in Year 1'];
        // state.roofAnalysis.formDetails.quickplantAnalysis.electricityGenerated2 = data[GenerationKey][0];
        state.roofAnalysis.formDetails.quickplantAnalysis.electricityGenerated2 = data[GenerationKey];
      } else {
        console.error('Data is either not an object or is empty');
      }
      state.isLoading = false
    })

    .addCase(fetchpVAPIMonthlyCase2.pending, (state, action) => {
      state.isLoading = true
    })
    .addCase(fetchpVAPIMonthlyCase2.rejected, (state, { payload }) => {
      state.isLoading = false;
      state.roofAnalysis.formDetails.quickplantAnalysis.electricityGenerated2 = null;
    })
    .addCase(fetchFinanceby.fulfilled, (state, { payload }: PayloadAction<FinRes>) => {
      state.roofAnalysis.formDetails.projectSummary.financial = payload;
      state.isLoading = false;

    })
    .addCase(fetchFinanceby.pending, (state, { payload }) => {
      state.isLoading = true;
    })
    .addCase(fetchFinanceby.rejected, (state, { payload }) => {
      state.isLoading = false;
      state.roofAnalysis.formDetails.projectSummary.financial = null;
    })
    .addCase(generationdegradation.fulfilled, (state, { payload }) => {
      state.roofAnalysis.formDetails.projectSummary.degradation = payload
      state.isLoading = false;
    })
    .addCase(generationdegradation.pending, (state, { payload }) => {
      // Add user to the state array
      state.isLoading = true;
    })
    .addCase(generationdegradation.rejected, (state, { payload }) => {
      state.roofAnalysis.formDetails.projectSummary.degradation = null
      state.isLoading = false;
    })


    .addCase(generationdegradationwithfinance2.fulfilled, (state, { payload }) => {

      // AC/DC are owned by the saved project (getCapacityFields: AC = sanction load, DC = AC x 1.2, or the admin's values).
      // The generation API's equipment totals (e.g. 51 kW AC for a 50 kW load) must not override them.

      state.roofAnalysis.formDetails.quickplantAnalysis.electricityGenerated2 = payload?.annualGeneration;
      state.roofAnalysis.formDetails.quickplantAnalysis.costbracket = payload?.degrdation?.totalplantCost;
      state.roofAnalysis.formDetails.quickplantAnalysis.performanceRatio = payload?.generation?.["Performance Ratio % in Year 1"]?.sum ?? 0;
      state.roofAnalysis.formDetails.projectSummary.financial = payload?.financialSaving;
      // state.roofAnalysis.formDetails.projectSummary.degradation = payload?.degrdation

      state.roofAnalysis.formDetails.projectSummary.degradation = {
        ...(payload?.degrdation ?? {}),
        savingperiod: payload?.degrdation?.paybackPeriodYears ?? 0, irr: payload?.degrdation?.irrPercent ?? 0, netsavings: payload?.degrdation?.lifecycleNetSavings ?? 0,
        carbonemission: payload?.financialSaving?.totalCarbonfootprint ?? 0
      };

      state.roofAnalysis.formDetails.quickplantAnalysis.environmentalImpact = payload?.environmentalImpact as EnvironmentalImpact
      state.roofAnalysis.formDetails.quickplantAnalysis.generationOutput = payload?.generation?.output ?? [];
      // }
      state.isLoading = false;
      state.generationLoading = false
    })
    .addCase(generationdegradationwithfinance2.pending, (state, { payload }) => {
      state.isLoading = true;
      state.generationLoading = true
    })
    .addCase(generationdegradationwithfinance2.rejected, (state, { payload }) => {
      state.isLoading = false;
      state.generationLoading = false
    })

    // generationwithfinances plant capacity
    .addCase(generationdegradationwithfinance.fulfilled, (state, { payload }) => {
      // debugger
      // if (typeof payload === 'object' && payload !== null && Object.keys(payload).length > 0){
      // state.roofAnalysis.formDetails.quickplantAnalysis.electricityGenerated = payload?.generation?.["annual energy="][0];
      state.roofAnalysis.formDetails.quickplantAnalysis.electricityGenerated = payload?.generation?.["pv_combined_out"]?.sum ?? 0;

      state.isLoading = false;
    })
    .addCase(generationdegradationwithfinance.pending, (state, { payload }) => {
      state.isLoading = true;
    })
    .addCase(generationdegradationwithfinance.rejected, (state, { payload }) => {
      state.isLoading = false;
    })

    // project api services builder 
    .addCase(deleteProjectbyId.pending, (state, { payload }) => { })
    .addCase(deleteProjectbyId.rejected, (state, { payload }) => {
      console.warn(payload, 'project could not be deleted')
    })
    .addCase(deleteProjectbyId.fulfilled, (state, { payload }) => {
      if (state.projects) {
        state.projects = state.projects.filter(ele => ele.projectid !== payload)
      }
      state.roofAnalysis.selected_project = null;
      // The index pointed into the old projects list — after the filter above it would select a different project
      state.roofAnalysis.selected_project_index = null;
      state.roofAnalysis.formDetails = initailFromdata

    })
}
